<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--  사업장 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 사업장 정보</h5>

      <div class="writeGridContainer">
        <div>
          <div>작업내용</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input v-else v-model="form.inputB_1" :readonly="board.readonly" />
        </div>

        <div>
          <div>조사일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <date-selector v-else v-model="form.inputB_5" :readonly="board.readonly" />
        </div>

        <div>
          <div>작업자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input v-else v-model="form.inputB_4" :readonly="board.readonly" />
        </div>

        <div>
          <div>재해형태(필수)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
          <disaster-class-selector v-else v-model="form.inputB_6" :readonly="board.readonly" :custom-disaster-list="customDisasterList" :multiple="true" />
        </div>
      </div>
    </div>

    <!--  청취조사 내용-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 청취조사 내용</h5>

      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>경험담 1</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputC_1 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputC_1" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>경험담 2</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputC_2 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputC_2" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>경험담 3</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputC_3 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputC_3" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!--  상세 내용-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 상세 내용 ※육하원칙(누가, 언제, 어디서, 무엇을, 어떻게, 왜)에 따라 작성</h5>

      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>근로자 의견</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputD_1 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputD_1" :readonly="board.readonly" placeholder="유해·위험 경험의 원인과 반성할 점" />
        </div>
        <div class="writeGridLineItem">
          <div>수행자 의견</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputD_2 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputD_2" :readonly="board.readonly" placeholder="경험에 대한 조언" />
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" class="mt-28px" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" class="mt-28px" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import {researchDisasters} from "@/util/DisasterDataResearch";

export default {
  components: {
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          종사자의견청취_사업장명: [],
          종사자의견청취_공정명: [],
        };

        value.summary["종사자의견청취_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["종사자의견청취_공정명"].push({
          [this.form.inputB_1]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",

        inputD_1: "",
        inputD_2: "",

        photoList: [],
        fileList: [],
      },
      customDisasterList: researchDisasters,
    };
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
